import {AxiosResponse} from 'axios'
import {axiosInstance} from 'src/utils/axios'
import {socialServiceURL, productServiceURL} from "../config"

export type ASPConfig = {
  isRestricted: boolean
  allowedProducts: string[]
}

export type ProductPrimitive = {
  id: string
  externalId: string
  title: string
  description: string
  pdpUrl: string
  handle: string
  featuredImage: {
    originalUrl: string
    smallUrl: string
    mediumUrl: string
    largeUrl: string
    altText: string
  } | null
  price: number
  comparePrice: number | null
  currencyCode: string
  totalInventory: number
}

export const getASPConfig = async (shop: string): Promise<AxiosResponse<ASPConfig>> => {
  const path = '/v3/shop/asp-config'
  const opts = {
    baseURL: socialServiceURL,
    headers: {
      'Content-Type': 'application/json',
      'shop': shop,
    },
  }
  return await axiosInstance.get<ASPConfig>(path, opts)
}

export const postASPConfig = async (shop: string, config: ASPConfig): Promise<AxiosResponse<{}>> => {
  const path = '/v3/shop/asp-config'
  const opts = {
    baseURL: socialServiceURL,
    headers: {
      'Content-Type': 'application/json',
      'shop': shop,
    },
  }
  return await axiosInstance.post(path, config, opts)
}

export const getProductsByIds = async (shop: string, productIds: string[]): Promise<AxiosResponse<ProductPrimitive[]>> => {
  const path = '/v1/products/primitives'
  const opts = {
    baseURL: productServiceURL,
    headers: {
      'Content-Type': 'application/json',
      'shop': shop,
    },
    params: {productIds: productIds.join(','), limit: productIds.length},
  }
  return await axiosInstance.get<ProductPrimitive[]>(path, opts)
}

export const searchProducts = async (shop: string, search: string, offset = 0, limit = 10): Promise<AxiosResponse<ProductPrimitive[]>> => {
  const path = '/v1/products/primitives'
  const opts = {
    baseURL: productServiceURL,
    headers: {
      'Content-Type': 'application/json',
      'shop': shop,
    },
    params: {search, offset, limit},
  }
  return await axiosInstance.get<ProductPrimitive[]>(path, opts)
}
